import { Star } from 'lucide-react'
import cx from 'classnames'
import TealToolTip from 'components/TealToolTip'

interface FavouriteButtonProps {
  isFavourite: boolean
  onClick: (e: React.MouseEvent) => void
  className?: string
}

export default function FavouriteButton ({ isFavourite, onClick, className }: FavouriteButtonProps): JSX.Element {
  const tooltipText = isFavourite ? 'Remove from Favourites' : 'Add to Favourites'

  return (
    <TealToolTip title={tooltipText} bgColor='dark' placement='top' arrow={false}>
      <button
        className={cx('pointer flex items-center justify-center bg-transparent hover-bg-ghost-white focus-bg-ghost-white w8 hs8 br2 p0', className)}
        onClick={onClick}
        aria-pressed={isFavourite}
        aria-label={tooltipText}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') onClick(e as any)
        }}
      >
        <Star
          strokeWidth={1.5}
          size={24}
          className={cx('w7 hs7 min-w7', {
            'star-yellow fill-star-yellow': isFavourite,
            grey: !isFavourite
          })}
        />
      </button>
    </TealToolTip>
  )
}
